window.theme = window.theme || {};

theme.ProductRecommendations = (function () {
  function ProductRecommendations(container) {
    this.container = container;

    var productId = this.container.dataset.productId;

    if (!productId) {
      return;
    }

    var recommendationsSectionUrl =
      "/recommendations/products?section_id=product-recommendations&product_id=" +
      productId +
      "&limit=4";

    fetch(recommendationsSectionUrl)
      .then(function (response) {
        return response.text();
      })
      .then(
        function (section) {
          var tempDiv = document.createElement("div");
          tempDiv.innerHTML = section;

          var recommendationsMarkup = tempDiv.innerHTML.trim();

          if (recommendationsMarkup !== "") {
            this.container.innerHTML = recommendationsMarkup;
          }
        }.bind(this)
      )
      .catch(function (error) {
        console.error("Product recommendations failed to load:", error);
      });
  }

  return ProductRecommendations;
})();

document.addEventListener("DOMContentLoaded", function () {
  if (window.theme && theme.Sections) {
    var sections = new theme.Sections();
    sections.register("product-recommendations", theme.ProductRecommendations);
    return;
  }

  var recommendationSections = document.querySelectorAll(
    '[data-section-type="product-recommendations"]'
  );

  recommendationSections.forEach(function (section) {
    new theme.ProductRecommendations(section);
  });
});